import { ReactNode } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";

import { AccountCreation } from "@/components/signup/account-creation/account-creation";
import { Social } from "@/components/signup/account-creation/components/social/social";
import { wacToken } from "@/libraries/design/foundations";

import { messages } from "./messages";

const containerCss = css({
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "48px",
    alignItems: "center",
    width: "100%",
    maxWidth: "1152px",
    marginInline: "auto",
    boxSizing: "border-box",
    paddingInline: "24px",
    paddingBlockStart: "48px",
    paddingBlockEnd: "24px",
    [media.above.md]: {
        gridTemplateColumns: "minmax(0, 1fr) 420px"
    },
    [media.below.md]: {
        paddingBlockStart: "32px",
        paddingBlockEnd: "0"
    }
});

const copyCss = css({
    display: "flex",
    flexDirection: "column",
    gap: "16px"
});

const headingCss = css({
    fontWeight: 800,
    fontSize: "48px",
    lineHeight: "56px",
    color: wacToken("color.primary.black"),
    margin: 0,
    [media.above.md]: {
        fontSize: "48px"
    },
    [media.below.sm]: {
        fontSize: "2.5rem"
    }
});

const headingAccentCss = css({
    color: wacToken("color.primary.blue")
});

const subheadingCss = css({
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "1.6",
    color: wacToken("color.primary.black"),
    margin: 0,
    maxWidth: "30rem",
    [media.below.sm]: {
        fontSize: "1rem"
    }
});

const formCardCss = css({
    width: "100%",
    [media.above.md]: {
        justifySelf: "end"
    }
});

export const PaidJiraAiHeaderV2 = () => (
    <section
        css={containerCss}
        data-testid="paid-jira-ai-header-v2"
        aria-labelledby="paid-jira-ai-header-v2-heading"
    >
        <div css={copyCss}>
            <h1 id="paid-jira-ai-header-v2-heading" css={headingCss}>
                <FormattedMessage
                    {...messages.heroHeading}
                    values={{
                        accent: (chunks: ReactNode) => (
                            <span css={headingAccentCss}>{chunks}</span>
                        )
                    }}
                />
            </h1>
            <p css={subheadingCss}>
                <FormattedMessage {...messages.heroSubheading} />
            </p>
        </div>
        <div css={formCardCss}>
            <AccountCreation
                Login={null}
                Social={<Social providers={{ google: "Google" }} />}
            />
        </div>
    </section>
);
